import type { MarketingPage, MethodStep, MemberStory } from "../../../src/content/types";
import { escapeHtml } from "./dom";

export function renderHero(page: MarketingPage, heroImage: string, ctaHref: string): string {
  return `
    <span class="kicker">${escapeHtml(page.heroKicker)}</span>
    <h1 class="display">${escapeHtml(page.heroHeadline)}</h1>
    <p class="subtitle">${escapeHtml(page.heroSub)}</p>
    ${heroImage}
    <ul class="exercise-list" style="border:none;margin-top:1.5rem;">
      ${page.transformationBullets.map((b) => `<li style="border:none;padding:0.3rem 0;">&#10003; ${escapeHtml(b)}</li>`).join("")}
    </ul>
    <a class="btn" href="${ctaHref}" style="margin-top:1rem;">${escapeHtml(page.ctaText)}</a>
  `;
}

export function renderStatGrid(page: MarketingPage): string {
  return `<div class="stat-grid">${page.statBlocks
    .map((s) => `<div class="stat"><span class="value">${escapeHtml(s.value)}</span><span class="label">${escapeHtml(s.label)}</span></div>`)
    .join("")}</div>`;
}

export function renderMethod(steps: MethodStep[]): string {
  return `
    <h2 class="section-title">The Groundwork Method</h2>
    <p class="section-lead">One free membership gives you access to everything.</p>
    <div class="method-steps">
      ${steps
        .map(
          (s) => `<div class="method-step">
            <div class="circle">${s.step}</div>
            <h3>${escapeHtml(s.title)}</h3>
            <p>${escapeHtml(s.description)}</p>
          </div>`,
        )
        .join("")}
    </div>
  `;
}

export function renderCompareTable(page: MarketingPage): string {
  return `
    <h2 class="section-title">What Makes Us Different</h2>
    <table class="compare-table">
      <thead><tr><th></th><th>Groundwork</th><th>Other Apps</th></tr></thead>
      <tbody>
        ${page.compareRows
          .map(
            (r) => `<tr>
              <td>${escapeHtml(r.feature)}</td>
              <td>${r.us ? '<span class="check">&#10003;</span>' : '<span class="cross">&mdash;</span>'}</td>
              <td>${r.them ? '<span class="check">&#10003;</span>' : '<span class="cross">&mdash;</span>'}</td>
            </tr>`,
          )
          .join("")}
      </tbody>
    </table>
  `;
}

export function renderFaqs(page: MarketingPage): string {
  return `
    <h2 class="section-title">FAQs</h2>
    <div class="faq">
      ${page.faqs
        .map(
          (f) => `<details><summary>${escapeHtml(f.question)}</summary><p>${escapeHtml(f.answer)}</p></details>`,
        )
        .join("")}
    </div>
  `;
}

export function renderStories(stories: MemberStory[]): string {
  return `
    <h2 class="section-title">Member Stories</h2>
    <div class="card-grid">
      ${stories
        .map(
          (s) => `<div class="card story-card">
            <div class="story-avatar">${escapeHtml(s.name.slice(0, 1))}</div>
            <div>
              <strong>${escapeHtml(s.name)}</strong>
              <div class="persona">${escapeHtml(s.persona)}</div>
              <p>${escapeHtml(s.quote)}</p>
            </div>
          </div>`,
        )
        .join("")}
    </div>
    <p class="story-disclaimer">Illustrative member stories &mdash; Groundwork Academy is free and these examples show typical use, not verified reviews.</p>
  `;
}

export function renderCta(page: MarketingPage, ctaHref: string): string {
  return `
    <div class="cta-block">
      <h2 class="display">Ready to Build Your Foundation?</h2>
      <a class="btn" href="${ctaHref}">${escapeHtml(page.ctaText)}</a>
      <div class="fine-print">Free membership &middot; Cancel anytime</div>
    </div>
  `;
}
